module.exports = __webpack_public_path__ + "static/media/Name items in order from biggest to smallest.ff9a82aa.mp3";